import * as md5 from "md5";

export function gravatarParams() {
  return "?d=mp&s=30";
}

export function getGravatarUrl(email:string) {
  return `http://gravatar.com/avatar/${md5(email)}${gravatarParams()}`
}

export function getPhotoUrl(user: any) {
  return user.photoURL ? user.photoURL : getGravatarUrl(user.email);
}


// WEBPACK FOOTER //
// ./src/utils/gravatar.ts